import {required} from 'vuelidate/lib/validators'
import { mapGetters, mapMutations} from 'vuex';

export default {
    props: ['popupType', 'selectedItem'],
    data() {
        return {
            form: {
                title: '',
                sort: 0,
            },
        }
    },

    validations: {
        form: {
            title: {
                required
            },
        }
    },
    computed: {
        ...mapGetters({
            material:'catalog/material',
        }),
    },
    watch:{
        material(e){
            if(e){
                this.form.title = e.title;
                this.form.sort = e.sort
            }
        }
    }, 
    methods: { 
        closePopup() {
            this.$emit('closePopup')
        },
        sendMaterial() {
            if(this.material){
                const payload = {
                    id: this.material.id,
                    data:this.form
                }
                this.$emit('changeMaterial', payload)
            }else{
                this.$emit('sendMaterial', this.form)
            }
        },
        ...mapMutations({
            changeMaterial: 'catalog/changeMaterial'
        }),
    },
    destroyed() {
        this.changeMaterial(null);
    }
}